import { Field } from "./field";
import { cr, mo } from "fire-wind-water";

// dateLimitType: string;   // 精确度

class DateTime extends Field {
  displaySelectType = "DATETIME";
  formatValue: any;
  modelDate: any;
  format: string;
  standardFormat: string;
  formatUse: string;
  dateLimitType: string;
  displayDateTimeType: string;
  mode: string;
  showTime: any;

  constructor(field) {
    super(field);
    const attr = ["dateLimitType"];
    cr.each(attr, (d) => {
      this[d] = field[d];
    });

    this.value = null;
    this.formatValue = null;
    this.model = null;
    this.modelDate = null;
    this.initFormat();
    this.isError();
  }

  setValue(val: any): void {
    if (cr.isString(val)) {
      val = val.replace(/-/g, "/");
      const v: any = mo(val).format("X");
      const mv = v * 1000;
      this.formatValue = mo(val).format(this.format);
      this.value = mo(val).format(this.formatUse);
      this.model = mo(mv).toDate();
    } else if (cr.isNumber(val)) {
      this.formatValue = mo(val * 1000).format(this.format);
      this.value = mo(val * 1000).format(this.formatUse);
      this.model = mo(val * 1000).toDate();
    } else {
      this.formatValue = val ? mo(val).format(this.format) : null;
      this.value = val ? mo(val).format(this.formatUse) : null;
      this.model = val || null;
    }
    this.dirty = true;
    this.isError();
  }

  initValue(val): void {
    this.setValue(val);
    this.dirty = false;
  }

  clearValue(): void {
    this.value = null;
    this.model = null;
    this.formatValue = null;
    this.modelDate = null;
    this.dirty = true;
    this.isError();
  }

  initFormat(): void {
    switch (this.dateLimitType) {
      case "YEAR":
        this.format = "YYYY";
        this.standardFormat = "yyyy";
        this.formatUse = "YYYY-01-01 00:00:00";
        this.displayDateTimeType = "YEAR";
        this.mode = "year";
        break;
      case "MONTH":
        this.format = "YYYY-MM";
        this.standardFormat = "yyyy-MM";
        this.formatUse = "YYYY-MM-01 00:00:00";
        this.displayDateTimeType = "MONTH";
        this.mode = "month";
        break;
      case "DAY":
        this.format = "YYYY-MM-DD";
        this.standardFormat = "yyyy-MM-dd";
        this.formatUse = "YYYY-MM-DD 00:00:00";
        this.displayDateTimeType = "DATE";
        this.mode = "date";
        break;
      case "HOUR":
        this.format = "YYYY-MM-DD HH";
        this.standardFormat = "yyyy-MM-dd HH";
        this.formatUse = "YYYY-MM-DD HH:00:00";
        this.displayDateTimeType = "DATETIME";
        this.mode = "date";
        this.showTime = {
          nzFormat: "HH",
        };
        break;
      case "MINUTE":
        this.format = "YYYY-MM-DD HH:mm";
        this.standardFormat = "yyyy-MM-dd HH:mm";
        this.formatUse = "YYYY-MM-DD HH:mm:00";
        this.displayDateTimeType = "DATETIME";
        this.mode = "date";
        this.showTime = {
          nzFormat: "HH:mm",
        };
        break;
      default:
        this.format = "YYYY-MM-DD HH:mm:ss";
        this.standardFormat = "yyyy-MM-dd HH:mm:ss";
        this.formatUse = "YYYY-MM-DD HH:mm:ss";
        this.displayDateTimeType = "DATETIME";
        this.mode = "date";
        this.showTime = {
          nzFormat: "HH:mm:ss",
        };
    }
  }

  isError(): void {
    this.setError();
    if (!this.value && parseInt(this.required) === 1) {
      this.error.required = true;
    }
    this.hasError();
  }
}

export { DateTime };
